import React, {FC} from 'react'
import {
    StyledCalendarWrapper,
    StyledCalendarHeader,
    StyledYearMonthGrid
} from '@components/commons/calendar-legacy/style.ts'
import {DPPropGetter, DPYear} from '@rehookify/datepicker'
import dayjs from '@/dayjs.ts'
import {ChevronLeftIcon, ChevronRightIcon} from '@components/ui/icon/Icon.tsx'
import {useTranslation} from '@/translations/i18n.tsx'
import {Button} from '@components/ui/button/Button.tsx'
import {View} from '@components/commons/calendar-legacy/Calendar.tsx'

type YearSelectorProps = {
    years: DPYear[]
    yearButton: (year: DPYear) => DPPropGetter
    nextYearsButton: () => DPPropGetter
    previousYearsButton: () => DPPropGetter
    currentYear: string
    setViewState: React.Dispatch<React.SetStateAction<View>>
}
export const YearSelector: FC<YearSelectorProps> = ({
    years,
    yearButton,
    nextYearsButton,
    previousYearsButton,
    currentYear,
    setViewState
}) => {
    const {t} = useTranslation()

    return (
        <StyledCalendarWrapper>
            <StyledCalendarHeader>
                <Button shape="square" variant="ghost" {...previousYearsButton()}>
                    <ChevronLeftIcon />
                </Button>
                <h3>{t('commons:year')}</h3>
                <Button shape="square" variant="ghost" {...nextYearsButton()}>
                    <ChevronRightIcon />
                </Button>
            </StyledCalendarHeader>
            <StyledYearMonthGrid>
                {years.map(year => (
                    <Button
                        key={year.year}
                        {...yearButton(year)}
                        variant={year.year.toString() == currentYear ? 'primary' : 'ghost'}
                        onClick={event => {
                            yearButton(year).onClick?.(event)
                            setViewState('date')
                        }}
                    >
                        {dayjs(year.$date).format('YYYY')}
                    </Button>
                ))}
            </StyledYearMonthGrid>
            <Button variant="ghost" onClick={() => setViewState('date')}>
                {t('commons:back')}
            </Button>
        </StyledCalendarWrapper>
    )
}
